const getEnvironment = (locationHref: string = window.location.href): string => {
    const LOCALHOST_IDENTIFIER = 'localhost:';
    const PROD_IDENTIFIER = '.prod.';
  
    if (locationHref.includes(LOCALHOST_IDENTIFIER)) {
      return 'development';
    }
  
    return locationHref.includes(PROD_IDENTIFIER) ? 'prod' : 'test';
  };
  
  export default getEnvironment;